import { FormControl } from '@angular/forms';

import * as Services from '@shared/core/services';

import { Observable } from 'rxjs';
import { map, delay, take } from 'rxjs/operators';
import { IMemberModel } from '@shared/state';

export const emailTakenValidator = (membersService: Services.MembersService, delayResponse: number = 0) =>
    (control: FormControl): Observable<OLO.Common.IValidators> | Promise<OLO.Common.IValidators> => {
        if (!control.value) return Promise.resolve(null);


        return membersService
            .validateLogin(`${control.value}`, OLO.Enums.LOGIN_TYPE.EMAIL_BASED_LOGIN)
            .pipe(
                delay(delayResponse),
                take(1),
                map(member => !member.IsOnlineRegistered ? null : { emailTaken: 'Email is taken' })
            );
    };

export const emailSelfUpdateValidator = (membersService: Services.MembersService, currentMember: Observable<IMemberModel>) =>
    (control: FormControl): Observable<OLO.Common.IValidators> | Promise<OLO.Common.IValidators> => {
        if (!control.value) return Promise.resolve(null);

        return new Promise(resolve => {

            currentMember
                .pipe(
                    take(1)
                ).subscribe(member => {
                    if (!member || member.Email === control.value) return resolve(null);


                    return membersService
                        .validateLogin(control.value, OLO.Enums.LOGIN_TYPE.EMAIL_BASED_LOGIN)
                        .subscribe(response => !response.MemberId ? resolve(null) : resolve({ emailUpdateTaken: 'Email is taken' }));
                });

        });
    };
